<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Delivery Order # {{ do_number }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            v-if="
              user_group === 'Supervisor' && delivery_order.is_verified == true
            "
            outlined
            dark
            @click="authorisedDelivery"
          >
            <v-icon>mdi-checkbox-marked-circle</v-icon>
            Authorised Delivery
          </v-btn>
          <!--  v-if="
              user_group === 'Supervisor' &&
                delivery_order.is_verified == true &&
                !this.disabled_disabled_authorised
            "-->
          <v-btn
            color="primary"
            class="mx-2"
            outlined
            dark
            @click="verify"
            v-if="
              user_group === 'Supervisor' &&
                delivery_order.is_verified != true &&
                !this.disabled_verify
            "
          >
            <v-icon>mdi-checkbox-marked-circle</v-icon>
            Rating Verified
          </v-btn>
          <v-dialog v-model="dialogVerify" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Are you sure you want to set this DO as verified?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeVerify"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="verifyConfirmed"
                  >YES</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="6" class="pt-2 mb-2">
          <v-row>
            <v-col cols="12" sm="12" class="pt-2 mb-2"
              >Consignee:
              <span v-if="do_data">
                {{ do_data.consignee_fullname }}
              </span></v-col
            >
            <v-col cols="12" sm="12" class="pt-2 mb-2"
              >Consignee Address:
              <span v-if="do_data"
                >{{ do_data.consignee_address }}
              </span></v-col
            >
            <v-col cols="12" sm="12" class="pt-2 mb-2"
              >Number of Cargos:
              <span v-if="do_data"> {{ do_data.item_quantity }} </span></v-col
            >
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" class="pt-2 mb-2">
          <v-row>
            <v-col cols="12" sm="6" class="pt-2 mb-2"
              >DO No.:
              <span v-if="do_data">{{ do_data.do_number }} </span></v-col
            >
            <v-col cols="12" sm="6" class="pt-2 mb-2"
              >BL No.:
              <span v-if="do_data">{{ do_data.bl_number }} </span></v-col
            >
            <v-col cols="12" sm="6" class="pt-2 mb-2"
              >Vessel:
              <span v-if="do_data">{{ selected_vessel.vessel_name }} </span>
            </v-col>
            <v-col cols="12" sm="6" class="pt-2 mb-2"
              >Voyage No.:
              <span v-if="do_data">{{ selected_vessel.voyage_number }} </span>
            </v-col>
            <v-col cols="12" sm="12" class="pt-2 mb-2 grey lighten-3"
              >Sheet No.:
              <span v-if="do_data"> {{ do_data.number }}</span></v-col
            >
            <v-col cols="12" sm="6" class="pt-2 mb-2"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card elevation="2">
          <v-card-title>Rating Information:</v-card-title>
          <v-card-text>
            <div>Rated by:</div>
            <p class="text-h4 text--primary" v-if="do_data">
              {{ do_data.current_username }}
            </p>
            <div>Rated Date</div>
            <div class="text-h4 text--primary" v-if="do_data">
              {{ do_data.date_time_added }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card elevation="2">
          <v-card-title>Current Charges:</v-card-title>
          <v-card-text>
            <div>Total Charged (GMD):</div>
            <p class="text-h4 text--primary" v-if="do_data">
              <span v-if="!do_data.total_charge_after_waved">
                {{ do_data.total_charge }}
              </span>
              <span v-if="do_data.total_charge_after_waved">
                {{ do_data.total_charge_after_waved }}
              </span>
            </p>

            <div>Waived Amount (GMD):</div>
            <div class="text-h4 text--primary" v-if="do_data">
              {{ do_data.waved_amount }}
            </div>
            <div>Days Spend:</div>
            <div class="text-h4 text--primary" v-if="do_data">
              {{ do_data.total_days_spend }}
            </div>
            <div>Days Charged:</div>
            <div class="text-h4 text--primary" v-if="do_data">
              {{ do_data.final_days_spend }}
            </div>
            <div>Days Excluded:</div>
            <div class="text-h4 text--primary" v-if="do_data">
              {{ do_data.total_days_excluded }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Delivery Order Cargo Listing
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        item-key="id"
        class="elevation-1"
        :search="search"
        :loading="loading_do_items"
        :items="delivery_order_items"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-btn
            icon
            class="grey lighten-4 mx-2"
            @click="doAction({ item: item })"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col>
      <v-row>
        <v-btn large class="primary" @click="backToPre">
          <v-icon>mdi-arrow-left-bold-box-outline</v-icon>
          Back
        </v-btn></v-row
      >
    </v-col>
  </v-container>
</template>

<script>
//const addVessel = () => import("./add-vessel");
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import { commonServices, getPeriod } from "@/services/common.services";
const departedVessel = createNamespacedHelpers("departed_vessels");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
export default {
  components: {
    // addVessel
  },
  data: () => ({
    dialogVerify: false,
    disabled_verify: false,
    disabled_authorised: true,
    vessel_departed_date: null,
    vessel_arrival_date: null,
    current_date: moment().format("YYYY-MM-DD"),
    is_transit: null,
    is_reefer: null,
    activeItem: null,
    do_data: null,
    menu: null,
    user_group: null,
    show: false,
    do_number: null,
    do_id: null,
    filteredList: null,
    search: "",
    menu_items: [{ title: "view DO", ref: "view_do", view: "all" }]
  }),

  computed: {
    ...departedVessel.mapState({
      departed_vessels: state => state.departed_vessels,
      selected_vessel: state => state.selected_vessel
    }),

    ...deliveryOrderNamespace.mapState({
      delivery_order: state =>
        state.delivery_order ? state.delivery_order : [],
      delivery_order_items: state => (state.do_items ? state.do_items : []),
      loading: state => state.loading,
      loading_do_items: state => state.loading_do_items
    }),

    header() {
      return [
        { text: "Cargo Number", value: "cargo_no" },
        { text: "Cargo Size", value: "cargo_size" },
        { text: "Cargo Type", value: "cargo_type" },
        { text: "Cargo Description", value: "cargo_description" },
        { text: "Seal Number", value: "seal_number" },
        { text: "Vehicle Tonnage", value: "vehicle_tonnage" },
        { text: "VIN Number", value: "vin_number" },
        { text: "Rated by", value: "current_username" }
        //{ text: "Action", value: "actions", align: "end", sortable: false }
      ];
    }
  },
  mounted() {
    this.do_data = this.delivery_order;
    this.do_id = this.delivery_order.id;
    this.do_number = this.delivery_order.do_number;
    this.loadDOItems();

    //console.log("user group", this.user_group);
  },
  created() {
    if (commonServices.getUserGroup()) {
      this.user_group = commonServices.getUserGroup();
    }
    this.loadValues();
  },
  watch: {
    dialogVerify(val) {
      val || this.closeDialog();
    }
  },
  methods: {
    ...deliveryOrderNamespace.mapActions([
      "fetchDeliveryOrders",
      "fetchDeliveryOrdersByVessel",
      "fetchDoItems"
    ]),
    loadValues() {
      this.vessel_departed_date = this.selected_vessel.departure_date;
      this.vessel_arrival_date = this.selected_vessel.arrival_date;
      this.cargo_type = "Full Container";
      if (this.delivery_order) {
        this.is_transit = this.delivery_order.is_transit;
        this.is_reefer = this.delivery_order.is_reefer;
      }
    },
    checkPeriod() {
      const old_days = this.delivery_order.current_days_spend
        ? this.delivery_order.current_days_spend
        : this.delivery_order.total_days_spend;
      const days_spend = commonServices.getDaysSpend(
        this.vessel_departed_date,
        this.vessel_arrival_date,
        this.is_transit,
        this.current_date
      );

      const old_period = getPeriod(old_days);
      const current_period = getPeriod(days_spend);

      if (old_period.period === current_period.period) {
        // console.log("true" , old_period.period + " " + current_period.period);
        return true;
      } else {
        //console.log("false" , old_period.period + " " + current_period.period);
        return false;
      }
    },
    authorisedDelivery() {
      console.log("authorised delivery");
      if (!this.checkPeriod()) {
        this.$swal.fire({
          type: "error",
          title: "Oops...",
          text:
            "You cannot authorise delivery. Current period defers from rated period, \n please rate again!"
        });
        return;
      }

      if (this.delivery_order.delivery_date != null) {
        this.$swal.fire({
          type: "error",
          title: "Oops...",
          text: "This item has already been delivered!"
        });
        return;
      }

      const data = {
        id: this.delivery_order.id,
        delivery_authorised: 1,
        delivery_authorised_date: commonServices.getCurrentDate(),
        delivery_authorised_by: commonServices.getCurrentUser()
      };

      this.$swal
        .fire({
          title: "Authorised Delivery?",
          type: "info",
          showCancelButton: true,
          confirmButtonText: "Yes"
        })
        .then(result => {
          /* Read more about isConfirmed, isDenied below */
          console.log(result);
          if (result && result.dismiss != "cancel") {
            if (data) {
              this.$store
                .dispatch("delivery_orders/authorisedDelivery", data)
                .then(res => {
                  this.$swal.fire(
                    `${res.success} and authorised`,
                    "",
                    "success"
                  );
                  // this.$noty.success(res.success);
                  this.disabled_authorised = true;
                  this.close();
                })
                .catch(({ response }) => {
                  if (response !== undefined) {
                    this.errors = response.error;
                    this.$swal.fire(response.error, "", "error");
                  }
                });
            }
          }
        });
    },
    verifyConfirmed() {
      console.log("verified");

      const data = {
        id: this.delivery_order.id,
        is_verified: 1,
        delivery_authorised: 1,
        verified_by: commonServices.getCurrentUser(),
        delivery_authorised_date: commonServices.getCurrentDate()
      };

      if (data) {
        this.$store
          .dispatch("delivery_orders/verifyDO", data)
          .then(res => {
            this.$noty.success(res.success);
            this.disabled_verify = true;
            this.close();
          })
          .catch(({ response }) => {
            if (response !== undefined) {
              this.errors = response.error;
            }
          });
      }
      this.closeDialog();
    },
    closeVerify() {
      this.closeDialog();
    },
    verify() {
      this.dialogVerify = true;
    },
    closeDialog() {
      this.dialogVerify = false;
    },

    doAction(item) {},
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },
    viewCharges(item) {
      console.log("view charges", item);
    },
    backToPre() {
      console.log("back to pre");
    },

    loadDOItems() {
      //console.log("action", item.item);

      if (this.do_data) {
        const do_id = this.do_data.id;
        this.fetchDoItems(do_id);
        this.do_number = this.do_number;
      } else {
        return;
      }
    }
  }
};
</script>

<style scoped>
.list {
  width: 100%;
}
</style>
